
import React, { memo } from 'react';
import { RankPill } from '../RankPill';
import { XpProgressBar } from '../XpProgressBar';
import { ConnectivityIndicator } from '../ConnectivityIndicator';

export const StatusSection = memo(() => {
  return (
    <>
      <RankPill />
      
      {/* XP Progress (expanded on mobile to fill space) */}
      <div className="flex-1 flex items-center px-1">
        <XpProgressBar />
      </div>
      
      {/* Connectivity Status */}
      <div className="flex items-center px-2">
        <ConnectivityIndicator />
      </div>
    </>
  );
});

StatusSection.displayName = 'StatusSection';
